import { useEffect, useState } from "react";

import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import SmallPieGraph from "../../../general/SmallPieGraph";
import styles from "./InfraL1.module.css";
import { InfraStore } from "./InfraStore";

function InfraL1({ distrito }) {
  const [situacaoEstradas, setSituacaoEstradas] = useState(null);
  const [manutencaoEstradas, setManutencaoEstradas] = useState(null);
  const [situacaoEstradasOldValue, setSituacaoEstradasOldValue] =
    useState(null);
  const [manutencaoEstradasOldValue, setManutencaoEstradasOldValue] =
    useState(null);

  const situacaoEstradasValue = InfraStore(
    (state) => state.situacaoEstradasValue
  );

  const manutencaoEstradasValue = InfraStore(
    (state) => state.manutencaoEstradasValue
  );

  const setSituacaoEstradasValue = InfraStore(
    (state) => state.setSituacaoEstradasValue
  );

  const setManutencaoEstradasValue = InfraStore(
    (state) => state.setManutencaoEstradasValue
  );

  const setSituacaoEstradasImage = InfraStore(
    (state) => state.setSituacaoEstradasImage
  );

  const setManutencaoEstradasImage = InfraStore(
    (state) => state.setManutencaoEstradasImage
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [situacaoEstradas, manutencaoEstradas] = await Promise.all([
          Api.getSituacaoEstradas(distrito, null, manutencaoEstradasValue),
          Api.getManutencaoEstradas(distrito, situacaoEstradasValue, null),
        ]);
        setSituacaoEstradas(Functions.buildPieGraphParams2(situacaoEstradas));
        setManutencaoEstradas(
          Functions.buildSmallPieGraphParams(manutencaoEstradas)
        );
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [distrito, situacaoEstradasValue, manutencaoEstradasValue]);

  const onSituacaoEstradasClick = (value) => {
    setSituacaoEstradasValue(value);
  };

  const onManutencaoEstradasClick = (value) => {
    setManutencaoEstradasValue(value);
  };

  return (
    <div className={styles.infraL1}>
      <div className={styles.smallPiegraph}>
        {situacaoEstradas && (
          <SmallPieGraph
            data={situacaoEstradas}
            text="SITUAÇÃO DAS ESTRADAS"
            onLegendClick={onSituacaoEstradasClick}
            currentValue={situacaoEstradasValue}
            oldValue={situacaoEstradasOldValue}
            onOldValue={setSituacaoEstradasOldValue}
            onImageReady={setSituacaoEstradasImage}
          />
        )}
      </div>

      <div className={styles.smallPiegraph}>
        {manutencaoEstradas && (
          <SmallPieGraph
            data={manutencaoEstradas}
            text="MANUTENÇÃO DAS ESTRADAS"
            onLegendClick={onManutencaoEstradasClick}
            currentValue={manutencaoEstradasValue}
            oldValue={manutencaoEstradasOldValue}
            onOldValue={setManutencaoEstradasOldValue}
            onImageReady={setManutencaoEstradasImage}
          />
        )}
      </div>
    </div>
  );
}

export default InfraL1;
